// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"ThemesTab_fieldset__Kugu4","legend":"ThemesTab_legend__lLnNp","select":"ThemesTab_select__1TkAM"};